import React, { useState, useEffect } from "react";
import { toastr } from 'react-redux-toastr';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from "../ui/card";
import { Upload } from "lucide-react";

const UpdateExtensionLogo = ({
  currentEXLogo,
  dispatchGetEXLogo,
  dispatchUpdateEXLogo,
}) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    dispatchGetEXLogo();
  }, [dispatchGetEXLogo]);

  const handleLogoChange = (e) => {
    const formData = new FormData();
    const file = e.target.files[0];
    formData.append('chrome_ex_logo', file);
    const fileSize = (file.size / (1024 * 1024)).toFixed(2);
    const validMimeTypes = [
      'image/jpeg', 'image/png', 'image/gif',
    ];

    if (!validMimeTypes.includes(file.type)) {
      toastr.error('Supported files are JPG, PNG, GIF');
      return;
    }

    if (fileSize > 10) {
      toastr.error('File size must be up to 10MB');
      return;
    }

    setImageSrc(URL.createObjectURL(file));
    dispatchUpdateEXLogo(formData);
  };

  return (
    <Card className="mb-8 shadow-sm">
      <CardHeader>
        <CardTitle className="text-xl font-bold">
          Brand Customization
        </CardTitle>
        <CardDescription>
          Customize how your extension appears to users
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">
              Update logo
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              This image will appear on Chrome Extensions deployed
              by your organization.
            </p>
          </div>

          <div>
            <h4 className="text-base font-medium mb-2">
              File upload
            </h4>
            <p className="text-sm text-gray-500 mb-2">
              White images & logos recommended
            </p>
            <p className="text-sm text-gray-500 mb-2">
              Files supported are JPG, PNG, GIF, up to 10MB file size.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Recommended dimensions are 275×55
            </p>

            <div className="relative">
              <input
                type="file"
                id="logo-upload"
                className="sr-only"
                accept="image/jpeg,image/png,image/gif"
                onChange={handleLogoChange}
              />
              <label
                htmlFor="logo-upload"
                className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 text-white rounded-md cursor-pointer hover:bg-indigo-700 transition-colors"
              >
                <Upload className="h-4 w-4 mr-2" />
                Browse
              </label>
            </div>
          </div>

          <div>
            <h4 className="text-base font-medium mb-2">
              Current logo
            </h4>
            <div className="rounded-md border border-gray-200 p-2 w-32 h-32 flex items-center justify-center bg-muted-foreground">
              {imageSrc &&
                <img src={imageSrc}
                  alt="logo"
                  className="img-responsive"
                />
              }
              {!imageSrc && currentEXLogo &&
                <img src={currentEXLogo}
                  alt="logo"
                  className="img-responsive"
                />
              }
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default UpdateExtensionLogo;